module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/suns_footer_image_01-6655212ec35b5bcfd8383e30ad812caf.jpg";